const initialState1 = {
  message: [],
  typedMessage: "",
  showChatFullScreen: false,
  translationLanguage: null,
  fromLanguage: "English",
};

export const chatReducer = (state = initialState1, action) => {
  switch (action.type) {
    case "SET_MESSAGE": {
      return {
        ...state,
        message: action.val,
      };
    }
    case "SET_SHOW_CHAT_FULL_SCREEN": {
      return {
        ...state,
        showChatFullScreen: action.val,
      };
    }
    case "SET_TYPED_MESSAGE": {
      return {
        ...state,
        typedMessage: action.val,
      };
    }
    case "SET_TRANSLATION_LANGUAGE": {
      return {
        ...state,
        translationLanguage: action.val,
      };
    }
    default:
      return state;
  }
};
